// extracted by mini-css-extract-plugin
export default {"InputError":"CG2DV"};